import { useTheme } from "styled-components";
import { IModalProps } from "../../@interfaces";
import CloseButton from "../closebutton";
import { Content, Header, ModalContainer, Overlay, Title } from "./style";



const BaseModal: React.FC<IModalProps> = ({ closeModal, children, width, height, title }) => {
  const theme = useTheme();

  return (
    <Overlay>
      <ModalContainer className="custom-scroll" width={width} height={height}>
        <Header>
          {title && <Title>{title}</Title>}
          <CloseButton handleClose={closeModal} color={theme.colors.black} styles={{ position: "absolute", top: 5, right: 5}}/>
        </Header>
        <Content>
          {/* @ts-ignore */}
          {children}
        </Content>
      </ModalContainer>
    </Overlay>
  )
}

export default BaseModal;